import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { Redirect } from "react-router"
import { isError } from "../../../state/helpers/Error"
import { addPriceLevelAction } from "../../../state/price-level/PriceLevelActions"
import PriceLevelService from "../../../state/price-level/PriceLevelService"
import PriceLevelForm from "../forms/PriceLevelForm"

const CreatePriceLevelComponent = () => {
    const [shouldRedirect, setShouldRedirect] = useState(false)
    const [error, setError] = useState("")
    const dispatch = useDispatch()

    const createPriceLevel = (form: { name: string }) => {
        PriceLevelService.create(form).then(res => {
            if (!isError(res)) {
                setError("")
                dispatch(addPriceLevelAction(res))
                setShouldRedirect(true)
            } else {
                setError("price_level.form.edit.create_error")
            }
        })
    }

    if (shouldRedirect) {
        return <Redirect to="/priceLevels/catalog" />
    }

    return (
        <>
            <PriceLevelForm error={error} onUpdateCallback={createPriceLevel}></PriceLevelForm>
        </>
    )
}

export default CreatePriceLevelComponent



// WEBPACK FOOTER //
// ./src/product/price-level/components/CreatePriceLevelComponent.tsx